// TODO columns should come from BE
// const dataStructure = {
//   key: "",
//   order: 0,
//   label: "",
//   enableResizing: true,
//   enableSorting: true,
//   size: 200,
// };

import ImageWithFallback from "@/components/ImageWithFallback";
import StatusBadge from "@/components/StatusBadge";

export const columns = () => {
  return [
    {
      accessorKey: "status",
      header: "Status",
      cell: ({ row }) => <StatusBadge status={row.getValue("status")} />,
    },
    {
      accessorKey: "order",
      header: "Order",
      size: 60,
      cell: ({ row }) => (
        <div className={"flex justify-center"}>{row.getValue("order")}</div>
      ),
    },
    {
      accessorKey: "code",
      header: "ID",
    },
    {
      accessorKey: "icon_url",
      header: "Icon",
      cell: ({ row }) => <ImageWithFallback url={row.getValue("icon_url")} />,
      enableResizing: false,
      enableSorting: false,
    },
  ];
};
